export function getTimeRange(type) {
  const now = new Date();
  let startDate = new Date(now);

  switch (type) {
    case '0': // 前一周
      startDate.setDate(now.getDate() - 7);
      break;
    case '1': // 前一个月
      startDate.setMonth(now.getMonth() - 1);
      break;
    case '2': // 前6个月
      startDate.setMonth(now.getMonth() - 6);
      break;
    case '3': // 前一年
      startDate.setFullYear(now.getFullYear() - 1);
      break;
    default:
      throw new Error('Invalid type parameter. Please use 0, 1, 2, or 3.');
  }

  // 格式化日期函数
  function formatDate(date) {
    const pad = (num) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  return {
    startTime: formatDate(startDate),
    endTime: formatDate(now),
  };
}
